import {
  ADMIN_MONETIZATION_REQUESTS_LOADED,
  ADMIN_MONETIZATION_REQUESTS_CLEAR,
  ADMIN_MONETIZATION_REQUEST_DETAILS_LOADED,
  ADMIN_MONETIZATION_REQUEST_DETAILS_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import {
  setFetchLoaderLoading,
  setFetchLoaderReset,
  setSubmissionLoaderLoading,
  setSubmissionLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

// --- Reducer corresponding actions ---
export function monetizationRequestsLoaded(requests) {
  return {
    type: ADMIN_MONETIZATION_REQUESTS_LOADED,
    payload: { requests },
  };
}

export function monetizationRequestsClear() {
  return { type: ADMIN_MONETIZATION_REQUESTS_CLEAR };
}

export function monetizationRequestDetailsLoaded(details) {
  return {
    type: ADMIN_MONETIZATION_REQUEST_DETAILS_LOADED,
    payload: { details },
  };
}

export function monetizationRequestDetailsClear() {
  return { type: ADMIN_MONETIZATION_REQUEST_DETAILS_CLEAR };
}


// --- API functions ---
async function fetchMonetizationRequestsApi(token, params, dispatch) {
  const response = await api.nestedParamsGet({
    path: 'admin/claims/monetization-requests',
    version: 'gateway',
    params,
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function fetchMonetizationRequestDetailsApi(token, id, dispatch) {
  const response = await api.get({
    path: `admin/claims/monetization-requests/${id}`,
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function updateMonetizationRequestApi(token, body, dispatch) {
  const response = await api.put({
    path: 'admin/claims/monetization-requests',
    version: 'gateway',
    token,
    body,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

// --- Public components actions ---
export function initiateFetchMonetizationRequests(params = {}) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const requests = await fetchMonetizationRequestsApi(adminToken, params, dispatch);
      dispatch(monetizationRequestsLoaded(requests));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function clearMonetizationRequests() {
  return (dispatch) => {
    dispatch(monetizationRequestsClear());
  };
}

export function initiateFetchMonetizationRequestDetails(id) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();
      if (!dataLoading) dispatch(setFetchLoaderLoading());
      const details = await fetchMonetizationRequestDetailsApi(adminToken, id, dispatch);
      dispatch(monetizationRequestDetailsLoaded(details));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setFetchLoaderReset());
    }
  };
}

export function clearMonetizationRequestDetails() {
  return (dispatch) => {
    dispatch(monetizationRequestDetailsClear());
  };
}

export function initiateUpdateMonetizationRequest(body) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { submissionLoading } } = getState();
      if (!submissionLoading) dispatch(setSubmissionLoaderLoading());
      await updateMonetizationRequestApi(adminToken, body, dispatch);
      dispatch(arriveNotice('Request updated successfully', 'ok'));
    } catch (e) {
      dispatch(arriveNotice(e.message));
    } finally {
      dispatch(setSubmissionLoaderReset());
    }
  };
}
